import ImageTextRowTwo from "./ImageTextRowTwo"

export default ImageTextRowTwo
